import { useState } from "react";
import Cleave from "cleave.js/react";
//-----------------------------------------------------
import AutoComplete from "src/components/common/autoComplete";
import { AsyncFormSelect, SelectOption } from "src/components/common/AsyncSelect";
import { states, cityStates } from "src/components/common/cityState";
import { User } from "src/components/main/authStore";
import { Link, useRouteLoaderData, Form } from "react-router-dom";
//-----------------------------------------------------
export const myOptions = {
    region: ["Hayward", "Fresno", "Sacramento", "LA", "Arizona"],
    department: {
        "In-House Labor": ["Potholing", "Locating", "Mapping&Surveying", "Scanning&Coring", "CCTV", "QA/QC", "Traffic Control", "Hydro Vac Excavation", "Straight Vacuum Services"],
        "Office": ["Executive", "Project Management", "Administration", "Accounting", "Marketing", "IT", "Safety"],
        "Location": ["LA", "Arizona"], 
        "Outside Service": ["Outside Service"]
    },
    phaseLevel: {
        "185": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "270": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"], 
        "304": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "1245":["Locator", "QEW", "Standby", "Scanning/Coring"],
        "Local 3":["Operating Engineer"],
        "Local 12":["Operating Engineer"],
        "Local 294":["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 300": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 652": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "SC Local 1184": ["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "Local 783":["Apprentice 1", "Apprentice 2", "Apprentice 3", "Apprentice 4", "Journeyman", "Foreman"],
        "Non-Union":["Non-Union"]
    },
}
export const myAccessOptions = {
    projects: ["edit", "view", "no"],
    assignments: ["yes", "no"],
    purchases: ["approver", "paid", "edit", "view", "no"],
    perDiem: ["editAll", "edit", "view", "no"],
    reports: ["editAll", "edit", "view", "no"],
    forms: ["editAll", "edit", "view", "no"],
    personel: ["edit", "view", "no"],
    fleets: ["edit", "view", "no"],
    calendar: ["view", "no"],
    timeOffs: ["editAll", "viewAll", "edit", "view"],
    office: ["yes", "no"],
    allOffice: ["edit", "view", "no"],
    outside: ["locator", "standby", "qew", "runner", "no"],
    outsideStatus: ["edit", "view", "no"],
    metrics: ["all", "yes", "no"], 
    newspaper: ["edit", "view", "no"],
    community: ["editAll", "edit", "view", "no"],
    trainings: ["edit", "view", "no"], 
}
const accesses = [
    {title: "Projects", key: "projects"},
    {title: "Assignments", key: "assignments"}, 
    {title: "Purchase", key: "purchases"}, 
    {title: "Per Diem", key: "perDiem"}, 
    {title: "Newspaper", key: "newspaper"}, 
    {title: "Fleets", key: "fleets"}, 
    {title: "Reports", key: "reports"}, 
    {title: "Forms", key: "forms"}, 
    {title: "Personel", key: "personel"}, 
    {title: "Calendar", key: "calendar"}, 
    {title: "Time Off", key: "timeOffs"}, 
    {title: "Office", key: "office"}, 
    {title: "Office Status", key: "allOffice"}, 
    {title: "Outside Service", key: "outside"}, 
    {title: "Outside Service Status", key: "outsideStatus"}, 
    {title: "Metrics", key: "metrics"},
    {title: "Trainings", key: "trainings"},
];
//-----------------------------------------------------
export default function UserForm({
    keyword
}: {
    keyword: "Add" | "Edit" | "Add Dispatch" | "Edit Dispatch"
}){
    const [user, setUser] = useState<User>((useRouteLoaderData("user") as User | undefined) || ({
        email: "", 
        firstName: "",
        middleName: "",
        lastName: "", 
        phoneNumber: "", 
        workPhone: "", 
        extension: "", 
        region: "", 
        department: "",
        role: "", 
        unionName : "",
        phaseLevel: "", 
        ssn: "", 
        birthDay: "", 
        driverLicense: "", 
        hireDate: "", 
        quitDate: "", 
        background: "", 
        competencyServices: [],
        
        projects: "", 
        assignments: "", 
        purchases: "", 
        perDiem: "", 
        newspaper: "", 
        fleets: "", 
        reports: "", 
        forms: "", 
        personel: "", 
        calendar: "",
        timeOffs: "", 
        office: "",
        allOffice: "",
        outside: "", 
        outsideStatus: "", 
        metrics: "", 
        trainings: "",

        street: "", 
        zipCode: "", 
        residence: "", 
        residenceState: "CA", 
        address: ""
        
    } as unknown as User));
    //-----------------------------------------------------
    return(
        <Form method = "post" className = "my-3">
            <div className = "d-flex">
                <div className = "flex-grow-1 px-3">
                    <div className = "d-flex my-2">
                        <input type = "hidden" name = "keyword" value = {keyword}/>
                        <input type = "hidden" name = "curUserId" value = {user.id}/>
                        <input type = "hidden" name = "curOutside" defaultValue = {user.outside || ""}/>
                        <input type = "hidden" name = "curOffice" defaultValue = {user.office || ""}/>
                        <label htmlFor = "email" className = "fw-bold me-3 py-2 required-field text-nowrap">Email:</label>
                        <input
                            required
                            type = "email"
                            className = "form-control"
                            id = "email"
                            name = "userEmail"
                            value = {user.email}
                            onChange = {e => setUser({...user, email: e.currentTarget.value.toLowerCase()})}
                        />
                    </div>
                    <div className = "d-flex my-2">
                        <label className = "fw-bold me-3 py-2">Name:</label>
                        <input
                            required placeholder = "First Name"
                            className = "form-control me-3"
                            name = "firstName"
                            value = {user.firstName}
                            onChange = {e => setUser({...user, firstName: e.currentTarget.value})}
                        />
                        <input
                            placeholder = "Middle Name"
                            className = "form-control me-3"
                            name = "middleName"
                            value = {user.middleName}
                            onChange = {e => setUser({...user, middleName: e.currentTarget.value})}
                        />
                        <input
                            required
                            placeholder = "Last Name"
                            className = "form-control"
                            name = "lastName"
                            value = {user.lastName}
                            onChange = {e => setUser({...user, lastName: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "d-flex my-2">
                        <label className = "fw-bold me-3 py-2">Phone:</label>
                        <Cleave
                            required
                            placeholder = "Mobile Phone"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            name = "phoneNumber"
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.phoneNumber}
                            onChange = {e => setUser({...user, phoneNumber: e.currentTarget.value})}
                        />
                        <Cleave
                            placeholder = "Work Phone"
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            name = "workPhone"
                            options = {{
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.workPhone}
                            onChange = {e => setUser({...user, workPhone: e.currentTarget.value})}
                        />
                        <input
                            placeholder = "Office Extension"
                            type = "number"
                            step = "any"
                            className = "form-control"
                            name = "extension"
                            value = {user.extension}
                            onChange = {e => setUser({...user, extension: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "d-flex my-2 align-items-center">
                        <label htmlFor = "address" className = "fw-bold me-3 py-2">Address:</label>
                        <AutoComplete
                            className = "m-2"
                            id = "address"
                            location = {user.address}
                            coords = {user.coords} 
                            locationName = "address" 
                            coordsName = "coords"
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "region" className = "fw-bold me-3 py-2">Region:</label>
                        <select
                            required
                            className = "form-control me-3"
                            name = "region"
                            id = "region"
                            value = {user.region}
                            onChange = {e => setUser({...user, region: e.currentTarget.value})}
                        >
                            <option value = "">Select</option>
                            {myOptions.region.map((o, oi) => <option key = {oi}>{o}</option>)}
                        </select>
                        <label htmlFor = "department" className = "fw-bold me-3 py-2">Department:</label>
                        <select
                            required
                            className = "form-control me-3"
                            name = "department"
                            id = "department"
                            value = {user.department}
                            onChange = {e => setUser({...user, department: e.currentTarget.value})}
                        >
                            <option value = "">Select</option>
                            {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                        </select>
                        <label htmlFor = "role" className = "fw-bold me-3 py-2">Role:</label>
                        {user.department !== "Outside Service"?
                        <input
                            required
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "role"
                            id = "role"
                            value = {user.role}
                            onChange = {e => setUser({...user, role: e.currentTarget.value})}
                        />:
                        <select
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "role"
                            id = "role"
                            value = {user.role}
                            onChange = {e => setUser({...user, role: e.currentTarget.value})}
                        >
                            <option value = "">Select</option>
                            <option>M&L</option>
                            <option>QEW</option>
                            <option>Gas Standby</option>
                        </select>
                        }
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "unionName" className = "fw-bold me-3 py-2">Union Name:</label>
                        <select
                            required
                            className = "form-control me-3"
                            style = {{flexGrow: 1}}
                            name = "unionName"
                            id = "unionName"
                            value = {user.unionName}
                            onChange = {e => setUser({...user, unionName: e.currentTarget.value})}
                        >
                            <option value = "">Select</option>
                            {Object.keys(myOptions.phaseLevel).map((o, oi) => <option key = {oi}>{o}</option>)}
                        </select>
                        {user.unionName !== "Runner"?<>
                        <label htmlFor = "phaseLevel" className = "fw-bold me-3 py-2">Phase and Level:</label>
                        <select
                            required
                            className = "form-control"
                            style = {{flexGrow: 1}}
                            name = "phaseLevel"
                            id = "phaseLevel"
                            value = {user.phaseLevel}
                            onChange = {e => setUser({...user, phaseLevel: e.currentTarget.value})}
                        >
                            <option value = "">Select</option>
                            {user.unionName?
                            myOptions.phaseLevel[user.unionName as keyof typeof myOptions.phaseLevel].map((option, i) => <option key = {i}>{option}</option>):null}
                        </select>
                        </>:null}
                    </div>
                    <div className = "my-2" style = {{display: "flex"}}>
                        <label htmlFor = "ssn" className = "fw-bold me-3 py-2">SSN:</label>
                        <Cleave
                            pattern = "[0-9]{3}-[0-9]{2}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            style = {{flexGrow: 1}}
                            name = "ssn"
                            id = "ssn"
                            options = {{
                                blocks:[3, 2, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                            value = {user.ssn}
                            onChange = {e => setUser({...user, ssn: e.currentTarget.value})}
                        />
                        <label htmlFor = "birthDay" className = "fw-bold me-3 py-2">Birthday:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "birthDay"
                            id = "birthDay"
                            className = "form-control"
                            value = {user.birthDay}
                            onChange = {e => setUser({...user, birthDay: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex align-items-center text-nowrap">
                        <label htmlFor = "driverLicense" className = "fw-bold mb-0 py-2">Driver License:</label>
                        <span className = "fw-bold ms-1 py-2 h3 mb-0 text-info" data-toggle = "tooltip" title = {`only accept Capitalized Letters and Numbers`}>ⓘ</span>
                        <input
                            id = "driverLicense"
                            name = "driverLicense"
                            pattern = "[A-Z0-9]*"
                            className = "ms-3 form-control"
                            value = {user.driverLicense}
                            onChange = {e => setUser({...user, driverLicense: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "hireDate" className = "fw-bold me-3 mb-0 py-2">Hire Date:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            required
                            name = "hireDate"
                            id = "hireDate"
                            className = "form-control"
                            value = {user.hireDate}
                            onChange = {e => setUser({...user, hireDate: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "quitDate" className = "fw-bold me-3 mb-0 py-2">Leave Date:</label>
                        <input
                            type = "date"
                            min = "1900-01-01"
                            max = "2999-12-31"
                            name = "quitDate"
                            id = "quitDate"
                            className = "form-control"
                            value = {user.quitDate ?? ""}
                            onChange = {e => setUser({...user, quitDate: e.currentTarget.value})}
                        />
                    </div>
                    {(user.outside !== "runner") && (user.outside !== "no")?
                    <>
                    <div className = "my-2 d-flex text-nowrap">
                        <label className = "fw-bold me-3 mb-0 py-2">Residence:</label>
                        <input
                            type = "text"
                            className = "form-control me-3"
                            placeholder = "Street"
                            name = "street"
                            value = {user.street}
                            onChange = {e => setUser({...user, street: e.currentTarget.value})}
                        />
                        <select
                            className = "form-control me-3"
                            name = "residence"
                            value = {user.residence || ""}
                            onChange = {e => setUser({...user, residence: e.currentTarget.value})}
                        >
                            <option value = "">Select City</option>
                            {user.residenceState && cityStates[user.residenceState as keyof typeof cityStates].map((option, i) => <option key = {i}>{option}</option>)}
                        </select>
                        <select
                            className = "form-control me-3"
                            name = "residenceState"
                            value = {user.residenceState}
                            onChange = {e => setUser({...user, residenceState: e.currentTarget.value})}
                        >
                            <option value = "">Select State</option>
                            {states.map((option, i) => <option key = {i}>{option}</option>)}
                        </select>
                        <input
                            type = "text"
                            className = "form-control"
                            placeholder = "Zip Code"
                            name = "zipCode"
                            value = {user.zipCode}
                            onChange = {e => setUser({...user, zipCode: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex text-nowrap">
                        <label htmlFor = "btlNumber" className = "fw-bold mb-0 me-3 py-2">BTL No.:</label>
                        <input
                            pattern = "[0-9]{2}-[0-9]{1}-[0-9]{4}|[0-9]{2}-[0-9]{4}|$^"
                            className = "form-control me-3"
                            name = "btlNumber"
                            id = "btlNumber"
                            value = {user.btlNumber}
                            onChange = {e => setUser({...user, btlNumber: e.currentTarget.value})}
                        />
                        <label htmlFor = "lanId" className = "fw-bold me-3 mb-0 py-2">Lan Id:</label>
                        <input
                            type = "text" 
                            name = "lanId"
                            id = "lanId"
                            className = "form-control"
                            maxLength = {4}
                            minLength = {4}
                            value = {user.lanId}
                            onChange = {e => setUser({...user, lanId: e.currentTarget.value.toUpperCase()})}
                        />
                    </div>
                    </>
                    :null}
                    <div className = "my-2 d-flex align-items-center">
                        <label htmlFor = "background" className = "fw-bold mb-0 me-3">Background:</label>
                        <textarea
                            className = "form-control"
                            id = "background"
                            name = "background"
                            style = {{width: "100%", height: "100%"}}
                            value = {user.background}
                            onChange = {e => setUser({...user, background: e.currentTarget.value})}
                        />
                    </div>
                    <div className = "my-2 d-flex align-items-center">
                        <label htmlFor = "competencyServiceIds" className = "fw-bold mb-0 me-3 text-nowrap">Competency:</label>
                        <div className = "flex-grow-1">
                            <AsyncFormSelect
                                inputId = "competencyServiceIds"
                                name = "competencyServiceIds[]"
                                fileName = "common/searchService.php"
                                placeholder = "Search services…"
                                isMulti = {true}
                                value = {user.competencyServices ?? []}
                                onChange = {next => setUser({ ...user, competencyServices: (next as SelectOption[]) ?? [] })}
                            />
                        </div>
                    </div>
                </div>
                <div className = "flex-grow-1 px-3">
                    <div className = "my-2 text-center fw-bold" style = {{fontSize: "150%"}}>Access Control</div>
                    <div className = "rounded border p-4 d-flex">
                        <div className = "m-1 flex-grow-1">
                            {accesses.map((item, itemIndex) => 
                            <div key = {itemIndex} className = "my-2 d-flex">
                                <label htmlFor = {item.key} className = "fw-bold mb-0 me-3 py-2 required-field text-nowrap">{item.title}:</label>
                                <select
                                    required
                                    className = "form-control flex-grow-1"
                                    id = {item.key}
                                    name = {item.key}
                                    value = {user[item.key as keyof User] as string}
                                    onChange = {e => setUser({...user, [item.key]: e.currentTarget.value})}
                                >
                                    <option value = "">Select</option>
                                    {myAccessOptions[item.key as keyof typeof myAccessOptions].map((o, oi) => <option key = {oi}>{o}</option>)}
                                </select>
                            </div>)}
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-3">
                <Link children = "Close" className = "btn btn-outline-secondary me-3" to = ".."/>
                <button children = {keyword} className = "btn btn-primary float-end" type = "submit"/>
            </div>
        </Form>
    )
}
